"use strict";
exports.__esModule = true;
exports.hasOptinCookie = exports.getOptIn = exports.OPTIN_TYPES = void 0;
var OPTIN_COOKIE_NAME = 'sb1-optin';
var OPTIN_AUTHENTICATED_COOKIE_NAME = 'sb1-optin-authenticated';
var OPTIN_TYPES;
(function (OPTIN_TYPES) {
    OPTIN_TYPES["FUNKSJONELL"] = "F";
    OPTIN_TYPES["STATISTIKK"] = "S";
    OPTIN_TYPES["MARKEDSFORING"] = "M";
})(OPTIN_TYPES = exports.OPTIN_TYPES || (exports.OPTIN_TYPES = {}));
function getOptinCookie(optinName) {
    var _a;
    if (optinName === null || optinName === void 0 ? void 0 : optinName.match(OPTIN_COOKIE_NAME || OPTIN_AUTHENTICATED_COOKIE_NAME)) {
        return (getCookieValue(optinName));
    }
    return (_a = getCookieValue(OPTIN_AUTHENTICATED_COOKIE_NAME)) !== null && _a !== void 0 ? _a : getCookieValue(OPTIN_COOKIE_NAME);
}
function findCookie(cookieVersion) {
    var allCookies = document.cookie.split('; ');
    return allCookies.filter(function (aCookie) {
        return aCookie.match(new RegExp(cookieVersion));
    });
}
function getCookieValue(cookieName) {
    var matchV2 = findCookie(cookieName + "-v2=(.*?)");
    if (matchV2.length > 0) {
        return matchV2[0].split('=')[1].replace(/,/g, '-');
    }
    var matchV1 = findCookie(cookieName + "=(.*?)-v");
    if (matchV1.length > 0) {
        return matchV1[0].split('=')[1].split('-v')[0].replace(/,/g, '-');
    }
    return null;
}
function mapCookieToObject(cookie) {
    var _a;
    var cookieEntries = cookie.split('-');
    return cookieEntries.reduce(function (result, cookieEntry) {
        if (cookieEntry === OPTIN_TYPES.FUNKSJONELL ||
            cookieEntry === OPTIN_TYPES.STATISTIKK ||
            cookieEntry === OPTIN_TYPES.MARKEDSFORING) {
            result[cookieEntry] = true;
        }
        return result;
    }, (_a = {},
        _a[OPTIN_TYPES.FUNKSJONELL] = false,
        _a[OPTIN_TYPES.STATISTIKK] = false,
        _a[OPTIN_TYPES.MARKEDSFORING] = false,
        _a));
}
function getOptIn(optinName) {
    var _a;
    var cookie = getOptinCookie(optinName);
    if (cookie !== null) {
        return mapCookieToObject(cookie);
    }
    return _a = {},
        _a[OPTIN_TYPES.FUNKSJONELL] = false,
        _a[OPTIN_TYPES.STATISTIKK] = false,
        _a[OPTIN_TYPES.MARKEDSFORING] = false,
        _a;
}
exports.getOptIn = getOptIn;
function hasOptedIn(optinType, optinName) {
    var _a;
    var obj = getOptIn(optinName);
    return (_a = obj[optinType]) !== null && _a !== void 0 ? _a : false;
}
function hasOptinCookie() {
    var matchV1 = document.cookie.match(new RegExp("(" + OPTIN_AUTHENTICATED_COOKIE_NAME + "|" + OPTIN_COOKIE_NAME + ")=(.*?)-v"));
    var matchV2 = document.cookie.match(new RegExp("(" + OPTIN_AUTHENTICATED_COOKIE_NAME + "-v2|" + OPTIN_COOKIE_NAME + "-v2)=(.*?)"));
    return !!(matchV2 || matchV1);
}
exports.hasOptinCookie = hasOptinCookie;
exports["default"] = { hasOptedIn: hasOptedIn };
//# sourceMappingURL=index.js.map